import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppLoadService } from './app-load.service';

export function parseUrl(appLoadService: AppLoadService) {
  return (): Promise<boolean> => appLoadService.initAppParams();
}

@NgModule({
  imports: [],
  providers: [
    AppLoadService,
    {
      provide: APP_INITIALIZER,
      useFactory: parseUrl,
      deps: [AppLoadService],
      multi: true,
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppLoadModule {}
